export const SEARCH_PARAM_KEYS = {
  ASK_WHY_SURVEY_ID: 'ask_why_survey_id',
  COMPARE_BY: 'compare_by',
  COMPARISON_ATTRIBUTE: 'comparison_attribute',
  COMPARISON_INCLUDE_ALL_OTHERS: 'comparison_include_all_others',
  COMPARISON_VALUES: 'comparison_values',
  DISPLAY_AS: 'display_as',
  QUESTION_OPTION: 'option_ids',
  QUOTA_GROUP: 'group_ids',
  ROW_OPERATOR: 'row_operator',
  TURF_BASKET_STATE: 'turf_basket_state',
  TURF_INCLUDE_SPECIAL: 'turf_include_special',
  TURF_ITEMS: 'turf_items',
  TURF_MAX_SIZE: 'turf_max_size',
  TURF_PINS: 'turf_pins',
  TURF_QUESTION: 'turf_question',
};

export const SURVEY_QUESTION_FIELDS_TO_MERGE = [
  'answers',
  'caption',
  'image',
  'isScreener',
  'questionSourceId',
  'richText',
  'showConceptImage',
  'text',
  'turf',
];
